import { render, staticRenderFns } from "./PageVegetarianDays.vue?vue&type=template&id=83ea7720&scoped=true"
import script from "./PageVegetarianDays.vue?vue&type=script&lang=js"
export * from "./PageVegetarianDays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ea7720",
  null
  
)

export default component.exports